export default {
  conditions: [],
}
